import { Injectable } from '@angular/core';
import { FortiFACBaseProvisioningService } from './base-provisioning.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { AdminDeploymentResponse } from 'app/records/admin.deployment.records';

@Injectable({
    providedIn: 'root'
})
export class AdminDeploymentsService extends FortiFACBaseProvisioningService {

    all(lastKey: string = ''): Observable<AdminDeploymentResponse> {
        let params = new HttpParams().set('limit', '64');
        if (lastKey) {
            params = params.set('lastKey', lastKey);
        }
        return this.get<AdminDeploymentResponse>("deployments/all", params);
    }
}

